module.exports = __webpack_public_path__ + "img/bottlesFar.d1022a44.jpg";